// src/data/organizations.js
// Top organizations in each mountain of influence

export const ORGANIZATIONS_BY_MOUNTAIN = {
  religion: [
    {
      name: 'The Vatican',
      category: 'Religious Institution',
      url: 'https://www.vatican.va',
      influence: 'Global spiritual leadership'
    },
    {
      name: 'World Council of Churches',
      category: 'Interfaith Organization',
      url: 'https://www.oikoumene.org',
      influence: 'Global church unity'
    },
    {
      name: 'Islamic Development Bank',
      category: 'Religious Financial',
      url: 'https://www.isdb.org',
      influence: 'Islamic world finance'
    },
    {
      name: 'Billy Graham Rapid Response Team',
      category: 'Christian Ministry',
      url: 'https://www.billygraham.org',
      influence: 'Christian evangelism'
    },
    {
      name: 'Compassion International',
      category: 'Christian NGO',
      url: 'https://www.compassion.com',
      influence: 'Global child development'
    },
    {
      name: 'World Vision International',
      category: 'Humanitarian NGO',
      url: 'https://www.wvi.org',
      influence: 'Global humanitarian aid'
    },
    {
      name: 'American Bible Society',
      category: 'Religious Organization',
      url: 'https://www.americanbible.org',
      influence: 'Bible distribution worldwide'
    },
    {
      name: 'Operation Mobilization',
      category: 'Missionary Organization',
      url: 'https://www.om.org',
      influence: 'Global missionary work'
    },
  ],
  family: [
    {
      name: 'Focus on the Family',
      category: 'Family Organization',
      url: 'https://www.focusonthefamily.com',
      influence: 'Family advocacy & counseling'
    },
    {
      name: 'Family Research Council',
      category: 'Policy Organization',
      url: 'https://www.frc.org',
      influence: 'Family policy advocacy'
    },
    {
      name: 'UNICEF',
      category: 'UN Agency',
      url: 'https://www.unicef.org',
      influence: 'Child welfare globally'
    },
    {
      name: 'Save the Children',
      category: 'NGO',
      url: 'https://www.savethechildren.net',
      influence: 'Child protection worldwide'
    },
    {
      name: 'International Family Planning',
      category: 'Health Organization',
      url: 'https://www.ippf.org',
      influence: 'Family health services'
    },
    {
      name: 'Planned Parenthood',
      category: 'Health Organization',
      url: 'https://www.plannedparenthood.org',
      influence: 'Reproductive health services'
    },
    {
      name: 'Council on Contemporary Families',
      category: 'Research Organization',
      url: 'https://www.contemporaryfamilies.org',
      influence: 'Family research & advocacy'
    },
    {
      name: 'National Organization for Women',
      category: 'Advocacy Group',
      url: 'https://now.org',
      influence: 'Women and family rights'
    },
  ],
  education: [
    {
      name: 'Harvard University',
      category: 'University',
      url: 'https://www.harvard.edu',
      influence: 'Higher education leadership'
    },
    {
      name: 'Stanford University',
      category: 'University',
      url: 'https://www.stanford.edu',
      influence: 'Innovation & education'
    },
    {
      name: 'MIT',
      category: 'University',
      url: 'https://www.mit.edu',
      influence: 'Technology & education'
    },
    {
      name: 'UNESCO',
      category: 'UN Agency',
      url: 'https://www.unesco.org',
      influence: 'Global education policy'
    },
    {
      name: 'World Bank Education Program',
      category: 'International Organization',
      url: 'https://www.worldbank.org/en/topic/education',
      influence: 'Education financing & policy'
    },
    {
      name: 'Khan Academy',
      category: 'EdTech Platform',
      url: 'https://www.khanacademy.org',
      influence: 'Free global education'
    },
    {
      name: 'Coursera',
      category: 'EdTech Platform',
      url: 'https://www.coursera.org',
      influence: 'Online education platform'
    },
    {
      name: 'Teach for All',
      category: 'NGO',
      url: 'https://teachforall.org',
      influence: 'Teacher recruitment & development'
    },
    {
      name: 'International Baccalaureate',
      category: 'Education Organization',
      url: 'https://www.ibo.org',
      influence: 'Global curriculum standards'
    },
  ],
  government: [
    {
      name: 'United Nations',
      category: 'International Organization',
      url: 'https://www.un.org',
      influence: 'Global governance'
    },
    {
      name: 'World Economic Forum',
      category: 'Policy Organization',
      url: 'https://www.weforum.org',
      influence: 'Global economic governance'
    },
    {
      name: 'United States Government',
      category: 'National Government',
      url: 'https://www.usa.gov',
      influence: 'Global political power'
    },
    {
      name: 'European Union',
      category: 'Regional Government',
      url: 'https://europa.eu',
      influence: 'Regional governance'
    },
    {
      name: 'OECD',
      category: 'Policy Organization',
      url: 'https://www.oecd.org',
      influence: 'Economic policy guidance'
    },
    {
      name: 'African Union',
      category: 'Regional Organization',
      url: 'https://au.int',
      influence: 'African governance'
    },
    {
      name: 'ASEAN',
      category: 'Regional Organization',
      url: 'https://asean.org',
      influence: 'Southeast Asian governance'
    },
    {
      name: 'Council on Foreign Relations',
      category: 'Think Tank',
      url: 'https://www.cfr.org',
      influence: 'Foreign policy influence'
    },
  ],
  media: [
    {
      name: 'BBC',
      category: 'Broadcasting',
      url: 'https://www.bbc.com',
      influence: 'Global news media'
    },
    {
      name: 'Reuters',
      category: 'News Agency',
      url: 'https://www.reuters.com',
      influence: 'Global news distribution'
    },
    {
      name: 'Associated Press',
      category: 'News Agency',
      url: 'https://apnews.com',
      influence: 'News distribution'
    },
    {
      name: 'The New York Times',
      category: 'Newspaper',
      url: 'https://www.nytimes.com',
      influence: 'Influential journalism'
    },
    {
      name: 'The Washington Post',
      category: 'Newspaper',
      url: 'https://www.washingtonpost.com',
      influence: 'Political journalism'
    },
    {
      name: 'CNN',
      category: 'Television Network',
      url: 'https://www.cnn.com',
      influence: 'Global news broadcasting'
    },
    {
      name: 'Al Jazeera',
      category: 'Television Network',
      url: 'https://www.aljazeera.com',
      influence: 'Global Arabic media'
    },
    {
      name: 'Meta Platforms',
      category: 'Social Media',
      url: 'https://www.meta.com',
      influence: 'Social media & messaging'
    },
    {
      name: 'Google',
      category: 'Tech & Media',
      url: 'https://www.google.com',
      influence: 'Information & advertising'
    },
    {
      name: 'Netflix',
      category: 'Streaming Platform',
      url: 'https://www.netflix.com',
      influence: 'Entertainment content distribution'
    },
  ],
  arts: [
    {
      name: 'The Metropolitan Museum of Art',
      category: 'Museum',
      url: 'https://www.metmuseum.org',
      influence: 'Global art & culture'
    },
    {
      name: 'Louvre Museum',
      category: 'Museum',
      url: 'https://www.louvre.fr',
      influence: 'Art preservation & exhibition'
    },
    {
      name: 'UNESCO World Heritage',
      category: 'Cultural Organization',
      url: 'https://whc.unesco.org',
      influence: 'Global cultural preservation'
    },
    {
      name: 'Royal Shakespeare Company',
      category: 'Theater Company',
      url: 'https://www.rsc.org.uk',
      influence: 'Theater & performance arts'
    },
    {
      name: 'Sundance Institute',
      category: 'Film Organization',
      url: 'https://www.sundance.org',
      influence: 'Independent film & storytelling'
    },
    {
      name: 'Academy Awards',
      category: 'Film Organization',
      url: 'https://www.oscars.org',
      influence: 'Film industry influence'
    },
    {
      name: 'Grammy Awards',
      category: 'Music Organization',
      url: 'https://www.grammy.com',
      influence: 'Music industry influence'
    },
    {
      name: 'Sony Music',
      category: 'Recording Label',
      url: 'https://www.sonymusic.com',
      influence: 'Global music distribution'
    },
    {
      name: 'Universal Music Group',
      category: 'Recording Label',
      url: 'https://www.universalmusic.com',
      influence: 'Music production & distribution'
    },
    {
      name: 'Netflix Productions',
      category: 'Production Company',
      url: 'https://www.netflix.com',
      influence: 'Content creation & distribution'
    },
  ],
  business: [
    {
      name: 'World Bank',
      category: 'Financial Institution',
      url: 'https://www.worldbank.org',
      influence: 'Global development finance'
    },
    {
      name: 'IMF',
      category: 'Financial Institution',
      url: 'https://www.imf.org',
      influence: 'Global economic policy'
    },
    {
      name: 'Goldman Sachs',
      category: 'Investment Bank',
      url: 'https://www.goldmansachs.com',
      influence: 'Global finance leadership'
    },
    {
      name: 'JPMorgan Chase',
      category: 'Banking',
      url: 'https://www.jpmorganchase.com',
      influence: 'Global banking'
    },
    {
      name: 'Apple Inc',
      category: 'Technology',
      url: 'https://www.apple.com',
      influence: 'Technology & innovation'
    },
    {
      name: 'Microsoft',
      category: 'Technology',
      url: 'https://www.microsoft.com',
      influence: 'Enterprise technology'
    },
    {
      name: 'Amazon',
      category: 'E-Commerce & Cloud',
      url: 'https://www.amazon.com',
      influence: 'Retail & cloud services'
    },
    {
      name: 'Berkshire Hathaway',
      category: 'Investment Holding',
      url: 'https://www.berkshirehathaway.com',
      influence: 'Investment & business leadership'
    },
    {
      name: 'Saudi Aramco',
      category: 'Energy',
      url: 'https://www.aramco.com',
      influence: 'Global energy supply'
    },
    {
      name: 'Shell Global',
      category: 'Energy',
      url: 'https://www.shell.com',
      influence: 'Global energy sector'
    },
    {
      name: 'Unilever',
      category: 'Consumer Goods',
      url: 'https://www.unilever.com',
      influence: 'Global consumer brands'
    },
    {
      name: 'Nestlé',
      category: 'Food & Beverage',
      url: 'https://www.nestle.com',
      influence: 'Global food industry'
    },
  ],
};

// Get organizations for a specific mountain
export const getOrganizationsByMountain = (mountainKey) => {
  return ORGANIZATIONS_BY_MOUNTAIN[mountainKey] || [];
};

// Get all organizations across all mountains
export const getAllOrganizations = () => {
  const all = [];
  Object.values(ORGANIZATIONS_BY_MOUNTAIN).forEach((orgs) => {
    all.push(...orgs);
  });
  return all;
};
